<template>
  <div>
    <v-row v-if="course" pt-5 no-gutters>
      <!--fist column -->
      <v-col cols="12" md="3">
        <v-card color="orange lighten-5" tile>
          <v-card-title class="font-weight-bold text-h5">
            <v-speed-dial
              v-if="isAdmin"
              class="mr-4"
              small
              v-model="fab"
              direction="bottom"
              transition="slide-y-transition"
            >
              <template v-slot:activator>
                <v-btn v-model="fab" color="blue darken-2" dark fab>
                  <v-icon v-if="fab">mdi-close</v-icon>
                  <v-icon v-else>mdi-school</v-icon>
                </v-btn>
              </template>
              <v-btn fab dark small color="green" @click.native="editItem(course)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn fab dark small color="red" @click.native="deleteItem(course)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-speed-dial>
            {{ course.name }}
          </v-card-title>
          <v-dialog v-model="dialog">
            <course-form
              :course="course"
              :formTitle="'Modifier cours'"
              @save="handleSaveCourse"
              @cancel="dialog = false"
              width="80%"
            />
          </v-dialog>

          <v-card-text>
            <div>Cours Détails - {{ course.id }}</div>
            <v-divider></v-divider>
            <table class="table_details_basic">
              <tbody>
                <tr>
                  <td width="10%">Nom:</td>
                  <td width="10%">{{ course.name }}</td>
                </tr>
                <tr>
                  <td width="10%">Type:</td>
                  <td width="10%">{{ course.type_full }}</td>
                </tr>
                <tr>
                  <td>Salle:</td>
                  <td>{{ course.room }}</td>
                </tr>
                <tr>
                  <td>Début:</td>
                  <td>{{ course.start | dateToHuman }}</td>
                </tr>
                <tr>
                  <td>Fin:</td>
                  <td>{{ course.end | dateToHuman }}</td>
                </tr>
                <tr>
                  <td>De:</td>
                  <td>{{ course.start_hours }}</td>
                </tr>
                <tr>
                  <td>À:</td>
                  <td>{{ course.end_hours }}</td>
                </tr>
                <tr>
                  <td>Jours:</td>
                  <td>
                    <span v-if="course.monday === 1">Lundi</span>
                    <span v-if="course.tuesday === 1">Mardi</span>
                    <span v-if="course.wednesday === 1">Mercredi</span>
                    <span v-if="course.thursday === 1">Jeudi</span>
                    <span v-if="course.friday === 1">Vendredi</span>
                    <span v-if="course.saturday === 1">Samedi</span>
                    <span v-if="course.sunday === 1">Dimanche</span>
                  </td>
                </tr>
                <tr v-if="course.working_days">
                  <td>Durée</td>
                  <td>{{ course.working_days.length }}</td>
                </tr>
                <tr>
                  <td>Formateur/trice 1:</td>
                  <td>{{ course.prof1 }}</td>
                </tr>
                <tr>
                  <td>Formateur/trice 2:</td>
                  <td>{{ course.prof2 }}</td>
                </tr>
                <tr>
                  <td>Google Drive Lien:</td>
                  <td>
                    <div v-if="course.drive_link">
                      <v-btn
                        v-bind:href="`${course.drive_link}`"
                        v-if="course.drive_link.substr(0, 4) === 'http'"
                        target="_blank"
                        text
                        icon
                        color="blue"
                      >
                        <v-icon>mdi-attachment</v-icon>
                      </v-btn>
                      <div v-else>Besoin d'un lien valide</div>
                    </div>
                    <div v-else>Il n'y pas un lien</div>
                  </td>
                </tr>
                <tr>
                  <td>Commentaire :</td>
                  <td>{{ course.comment }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- second column -->
      <v-col cols="12" md="9">
        <v-row>
          <v-col cols="12" md="4">
            <v-date-picker
              v-model="selectedDate"
              :min="course.start"
              :max="course.end"
              no-title
              locale="fr-CH"
              first-day-of-week="1"
              full-width
              :allowed-dates="functionEvents"
              :events="functionEvents"
              event-color="green"
            ></v-date-picker>
          </v-col>
          <v-col cols="12" md="8" v-if="new Date(course.start) > new Date()">
            <v-subheader style="color: green; font-size: 2vw">Ce cours n'a pas encore commencé</v-subheader>
            <v-subheader>total nombre de cours {{ course.countCourseDays() }}</v-subheader>
          </v-col>
          <v-col cols="12" md="8" v-else-if="new Date(course.end) < new Date()">
            <v-subheader style="color: blue; font-size: 2vw">Ce cours est déjà terminé</v-subheader>
            <v-subheader>total nombre de cours {{ course.countCourseDays() }}</v-subheader>
          </v-col>
          <v-col cols="12" md="8" v-else>
            <v-subheader>total nombre de cours {{ course.countCourseDays() }}:</v-subheader>
            <v-progress-linear
              :value="(this.course.countCourseDaysPassed() / this.course.countCourseDays()) * 100"
              rounded
              height="25"
            >
              <strong style="text-align: center">{{ course.countCourseDaysPassed() }} cours effectués</strong>
            </v-progress-linear>
            <v-subheader color="purple">
              {{ course.countCourseDays() - course.countCourseDaysPassed() }}
              cours restants
            </v-subheader>
          </v-col>
          <v-col cols="12">
            <students-in-course
              :course="this.course"
              :date="this.selectedDate"
              :loadingExternal="this.loading"
              @update="getDataFromApi()"
              @dateChange="handleDateChange"
            ></students-in-course>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import StudentsInCourse from "@/components/courses/StudentsInCourse.vue"
import { mapGetters } from "vuex"
import Course from "@/models/Course"
import CourseForm from "@/components/courses/CourseForm.vue"

export default {
  props: ["course_id"],
  components: {
    StudentsInCourse,
    CourseForm,
  },
  async mounted() {
    await this.getDataFromApi()
  },
  watch: {
    async course_id() {
      // Re-fetch data when navigating to a different course
      await this.getDataFromApi()
    },
    async selectedDate(val) {
      await this.getDataFromApi()
    },
  },
  data() {
    return {
      statusVariants: ["confirmé", "annulé", "en attente"],
      selectedDate: "",
      fab: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      date: null,
      loading: false,
      formTitle: "Modifier",
      dialog: false,
      valid: false,
    }
  },
  methods: {
    functionEvents(date) {
      return this.course?.working_days.includes(date)
    },
    async getDataFromApi() {
      this.loading = true
      await Course.getOneCourseWithStudentsById(this.course_id, this.selectedDate)
      this.loading = false
    },
    async deleteItem(item) {
      confirm("Are you sure you want to delete this course from your database, you will lose all data?") &&
        (await Course.deleteOne(this.course.id))
          .then(() => {
            this.$router.push("/")
          })
          .catch((error) => {
            console.log(error)
          })
    },
    async handleSaveCourse(course) {
      this.close()
      if (course.id != null) {
        await Course.update(course)
      } else {
        await Course.create(course)
      }
      await this.getDataFromApi()
    },
    editItem() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    handleDateChange(date) {
      // Update selectedDate which triggers watcher to fetch data
      this.selectedDate = date
    },
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    course() {
      let course = Course.query().where("id", this.course_id).first()
      if (!course) {
        return new Course()
      }
      return course
    },
  },
}
</script>

<style scoped>
tbody > tr {
  border-bottom: 1px solid black;
}

tbody > tr > td:nth-child(1) {
  font-weight: bolder;
}

tbody > tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

tbody > tr > td {
  text-align: left;
  padding: 0px 7px;
}

.vdp-datepicker input {
  width: 75px;
  height: 20px;
}

.v-date-picker-table {
  height: 100%;
}
</style>
